import CONTACTS from 'constants/Contacts'
import * as C from 'constants/Redux'

const PREFIX = 'CONTACTS / '
const DEPARTMENTS = `${PREFIX}DEPARTMENTS`
const CALL_QUEUES = `${PREFIX}CALL_QUEUES`
const WELCOME_MENUS = `${PREFIX}WELCOME_MENUS`
const TEAM_MEMBERS = `${PREFIX}TEAM_MEMBERS`
const RING_GROUPS = `${PREFIX}RING_GROUPS`
const GUESTS = `${PREFIX}GUESTS`
const SELECTED = `${PREFIX}SELECTED`
const SYNC_TOKEN = `${PREFIX}SYNC_TOKEN`

// departments
export const DEPARTMENTS_FETCH = DEPARTMENTS + C.FETCH
export const DEPARTMENTS_FETCH_PENDING = DEPARTMENTS_FETCH + C.PENDING
export const DEPARTMENTS_FETCH_FULFILLED = DEPARTMENTS_FETCH + C.FULFILLED
export const DEPARTMENTS_FETCH_REJECTED = DEPARTMENTS_FETCH + C.REJECTED

// call queues
export const CALL_QUEUES_FETCH = CALL_QUEUES + C.FETCH
export const CALL_QUEUES_FETCH_PENDING = CALL_QUEUES_FETCH + C.PENDING
export const CALL_QUEUES_FETCH_FULFILLED = CALL_QUEUES_FETCH + C.FULFILLED
export const CALL_QUEUES_FETCH_REJECTED = CALL_QUEUES_FETCH + C.REJECTED

// welcome menus
export const WELCOME_MENUS_FETCH = WELCOME_MENUS + C.FETCH
export const WELCOME_MENUS_FETCH_PENDING = WELCOME_MENUS_FETCH + C.PENDING
export const WELCOME_MENUS_FETCH_FULFILLED = WELCOME_MENUS_FETCH + C.FULFILLED
export const WELCOME_MENUS_FETCH_REJECTED = WELCOME_MENUS_FETCH + C.REJECTED

// team members
export const TEAM_MEMBERS_FETCH = TEAM_MEMBERS + C.FETCH
export const TEAM_MEMBERS_FETCH_PENDING = TEAM_MEMBERS_FETCH + C.PENDING
export const TEAM_MEMBERS_FETCH_FULFILLED = TEAM_MEMBERS_FETCH + C.FULFILLED
export const TEAM_MEMBERS_FETCH_REJECTED = TEAM_MEMBERS_FETCH + C.REJECTED

// ring groups
export const RING_GROUPS_FETCH = RING_GROUPS + C.FETCH
export const RING_GROUPS_FETCH_PENDING = RING_GROUPS_FETCH + C.PENDING
export const RING_GROUPS_FETCH_FULFILLED = RING_GROUPS_FETCH + C.FULFILLED
export const RING_GROUPS_FETCH_REJECTED = RING_GROUPS_FETCH + C.REJECTED

// guest
export const GUESTS_FETCH = GUESTS + C.FETCH
export const GUESTS_FETCH_PENDING = GUESTS_FETCH + C.PENDING
export const GUESTS_FETCH_FULFILLED = GUESTS_FETCH + C.FULFILLED
export const GUESTS_FETCH_REJECTED = GUESTS_FETCH + C.REJECTED

// search
export const SEARCH = `${PREFIX}SEARCH`
export const SEARCH_FULFILLED = SEARCH + C.FULFILLED
export const SEARCH_KEY_PENDING = `${SEARCH}_KEY${C.PENDING}`
export const SEARCH_KEY_FULFILLED = `${SEARCH}_KEY${C.FULFILLED}`
export const SEARCH_CLEAR = SEARCH + C.CLEAR

// search selected contact for outgoing call
export const SELECTED_SET = SELECTED + C.SET
export const SELECTED_CLEAR = SELECTED + C.CLEAR

// sync token
export const SYNC_TOKEN_SET = SYNC_TOKEN + C.SET
export const SYNC_TOKEN_CLEAR = SYNC_TOKEN + C.CLEAR

// search for transfer
const TYPE = `${SELECTED}_TYPE`
export const SELECTED_TYPE_SET = TYPE + C.SET
export const SELECTED_TYPE_CLEAR = TYPE + C.CLEAR

export const DATA_MAP = 'contacts'
export const LOADING = 'Loading'
export const ERROR = 'Error'

const initialState = {
  [DATA_MAP]: {},
}

CONTACTS.list.forEach((type) => {
  initialState[type + LOADING] = false
  initialState[type + ERROR] = false
  initialState[DATA_MAP][type] = []
})

export const INITIAL_STATE = {
  ...initialState,
  search: '',
  filteredIds: [],
  selected: false,
  type: false,
}
